import { render, staticRenderFns } from "./QrDetailsWidget.vue?vue&type=template&id=3451ba08&scoped=true"
import script from "./QrDetailsWidget.vue?vue&type=script&lang=js"
export * from "./QrDetailsWidget.vue?vue&type=script&lang=js"
import style0 from "./QrDetailsWidget.vue?vue&type=style&index=0&id=3451ba08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3451ba08",
  null
  
)

export default component.exports